import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DefaultEditor } from 'ng2-smart-table';

@Component({
  template: `
    <div class="input-group mb-3" style="margin-top:15px;">
      <div class="input-group-prepend">
        <span class="input-group-text" style="padding:4px;">
          <mat-icon class="mat-icon md-6">attach_money</mat-icon>
        </span>
      </div>
      <input [ngClass]="inputClass"
             #amount
             min="0"
             class="form-control short-input"
             type="number"
             [name]="cell.getId()"
             [placeholder]="0"
             [disabled]="!cell.isEditable()"
             (click)="onClick.emit($event)"
             (keyup)="updateValue()"
             (keydown.enter)="onEdited.emit($event)"
             (keydown.esc)="onStopEditing.emit()"
      />
    </div>`,
})
export class CustomAmountEditorComponent extends DefaultEditor implements AfterViewInit {

  @ViewChild('amount', { static: false }) amount: ElementRef;

  constructor() {
    super();
  }

  ngAfterViewInit() {

    if (this.cell.newValue !== '') {
      this.amount.nativeElement.value = this.cell.newValue;
    } else if (this.cell.getId() === 'offset') {
        this.cell.newValue = 0;
    }
  }

  updateValue() {
    this.cell.newValue = this.amount.nativeElement.value;
  }

}
